function round(value, places) {
    if (Number.isFinite(value)) {
        const scale = Math.pow(10, places);
        return Math.round(value * scale) / scale;
    }

    return value;
}

export { round }